'use strict';
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dOut$002dOf$002dOffice$0024$0024anon$002411 from "./app.data.-General-Practice-User-Out-Of-Office$$anon$11.js";
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dOut$002dOf$002dOffice$0024$0024anon$002413 from "./app.data.-General-Practice-User-Out-Of-Office$$anon$13.js";
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dOut$002dOf$002dOffice$0024$0024anon$002414 from "./app.data.-General-Practice-User-Out-Of-Office$$anon$14.js";
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dOut$002dOf$002dOffice$0024$0024anon$002416 from "./app.data.-General-Practice-User-Out-Of-Office$$anon$16.js";
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dOut$002dOf$002dOffice$0024$0024anon$00247 from "./app.data.-General-Practice-User-Out-Of-Office$$anon$7.js";
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dOut$002dOf$002dOffice$0024$0024anon$00248 from "./app.data.-General-Practice-User-Out-Of-Office$$anon$8.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $s_Lapp_data_GeneralPracticeUserOutOfOffice$__app$data$GeneralPracticeUserOutOfOffice$$anon$6$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.Lmagnolia1_TypeInfo__f_typeParams.toList__sci_List();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var x0 = rest.head__O();
    var this$2 = $s_Lapp_data_GeneralPracticeUserOutOfOffice$__app$data$GeneralPracticeUserOutOfOffice$$anon$6$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq(x0);
    var it = this$2.prepended__O__O(x0).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.next__O(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = rest.tail__O();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_data_GeneralPracticeUserOutOfOffice$__app$data$GeneralPracticeUserOutOfOffice$$anon$6$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_data_GeneralPracticeUserOutOfOffice$__app$data$GeneralPracticeUserOutOfOffice$$anon$6$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite__Lapp_data_GeneralPracticeUserOutOfOffice() {
  $m_Lapp_data_GeneralPracticeUserOutOfOffice$();
  return $t_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite;
}
export { $s_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite__Lapp_data_GeneralPracticeUserOutOfOffice as $s_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite__Lapp_data_GeneralPracticeUserOutOfOffice };
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserOutOfOffice$() {
  this.Lapp_data_GeneralPracticeUserOutOfOffice$__f_derived$Schema$lzy1 = null;
  this.Lapp_data_GeneralPracticeUserOutOfOffice$__f_derived$Schemabitmap$1 = false;
  this.Lapp_data_GeneralPracticeUserOutOfOffice$__f_derived$CirceCodec$lzy1 = null;
  this.Lapp_data_GeneralPracticeUserOutOfOffice$__f_derived$CirceCodecbitmap$1 = false;
  $n_Lapp_data_GeneralPracticeUserOutOfOffice$ = this;
  $t_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite = new $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3("Indefinite", 0);
}
export { $c_Lapp_data_GeneralPracticeUserOutOfOffice$ as $c_Lapp_data_GeneralPracticeUserOutOfOffice$ };
$c_Lapp_data_GeneralPracticeUserOutOfOffice$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserOutOfOffice$.prototype.constructor = $c_Lapp_data_GeneralPracticeUserOutOfOffice$;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserOutOfOffice$() {
}
export { $h_Lapp_data_GeneralPracticeUserOutOfOffice$ as $h_Lapp_data_GeneralPracticeUserOutOfOffice$ };
$h_Lapp_data_GeneralPracticeUserOutOfOffice$.prototype = $c_Lapp_data_GeneralPracticeUserOutOfOffice$.prototype;
$c_Lapp_data_GeneralPracticeUserOutOfOffice$.prototype.derived$Schema__Lsttp_tapir_Schema = (function() {
  if ((!this.Lapp_data_GeneralPracticeUserOutOfOffice$__f_derived$Schemabitmap$1)) {
    var SchemaMagnoliaDerivation_this = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    $m_Lapp_data_GeneralPracticeUserOutOfOffice$();
    var derivation = new $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6(SchemaMagnoliaDerivation_this);
    var typeParams = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var typeInfo = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lmagnolia1_TypeInfo("app.data", "GeneralPracticeUserOutOfOffice", typeParams);
    var result$proxy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var tc = new $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9(derivation);
    var isType = new $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10();
    var asType = new $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dOut$002dOf$002dOffice$0024$0024anon$002411.$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$11();
    var typeParams$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lmagnolia1_TypeInfo("app.data", "Indefinite", typeParams$1);
    var elements = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(0);
    var iterator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    var i = 0;
    while ((i < 0)) {
      elements.u[i] = iterator.next__O();
      i = ((1 + i) | 0);
    }
    var elements$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(0);
    var iterator$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    var i$1 = 0;
    while ((i$1 < 0)) {
      elements$1.u[i$1] = iterator$1.next__O();
      i$1 = ((1 + i$1) | 0);
    }
    var elements$2 = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)(0);
    var iterator$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    var i$2 = 0;
    while ((i$2 < 0)) {
      elements$2.u[i$2] = iterator$2.next__O();
      i$2 = ((1 + i$2) | 0);
    }
    var sub = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_SealedTrait$Subtype($x_1, elements, elements$1, elements$2, false, 0, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CallByNeed$().createLazy__F0__Lmagnolia1_CallByNeed(tc), isType, asType), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var result$proxy2 = result$proxy1.$colon$colon$colon__sci_List__sci_List(sub);
    var tc$2 = new $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12(derivation);
    var isType$2 = new $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15();
    var asType$2 = new $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dOut$002dOf$002dOffice$0024$0024anon$002416.$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$16();
    var typeParams$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lmagnolia1_TypeInfo("app.data.GeneralPracticeUserOutOfOffice", "Finite", typeParams$2);
    var elements$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(0);
    var iterator$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    var i$3 = 0;
    while ((i$3 < 0)) {
      elements$3.u[i$3] = iterator$3.next__O();
      i$3 = ((1 + i$3) | 0);
    }
    var elements$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(0);
    var iterator$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    var i$4 = 0;
    while ((i$4 < 0)) {
      elements$4.u[i$4] = iterator$4.next__O();
      i$4 = ((1 + i$4) | 0);
    }
    var elements$5 = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)(0);
    var iterator$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    var i$5 = 0;
    while ((i$5 < 0)) {
      elements$5.u[i$5] = iterator$5.next__O();
      i$5 = ((1 + i$5) | 0);
    }
    var sub$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_SealedTrait$Subtype($x_2, elements$3, elements$4, elements$5, false, 1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CallByNeed$().createLazy__F0__Lmagnolia1_CallByNeed(tc$2), isType$2, asType$2), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
    var result$proxy3 = result$proxy2.$colon$colon$colon__sci_List__sci_List(sub$2);
    if ((result$proxy3.lengthCompare__I__I(1) <= 0)) {
      var $x_3 = result$proxy3;
    } else {
      var builder = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_ListBuffer();
      var seen = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_scm_HashSet__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_scm_HashSet());
      var it$6 = result$proxy3.iterator__sc_Iterator();
      var different = false;
      while (it$6.hasNext__Z()) {
        var next = it$6.next__O();
        if (seen.add__O__Z(next.Lmagnolia1_SealedTrait$Subtype__f_typeInfo)) {
          builder.addOne__O__scm_ListBuffer(next);
        } else {
          different = true;
        }
      }
      var $x_3 = (different ? builder.toList__sci_List() : result$proxy3);
    }
    var this$22 = $x_3;
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$9) => _$9.Lmagnolia1_SealedTrait$Subtype__f_typeInfo.full__T()));
    var ord = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_math_Ordering$String$();
    var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$22, f, ord);
    var len = xs.length__I();
    var array = new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lmagnolia1_SealedTrait$Subtype.getArrayOf().constr)(len);
    var iterator$6 = xs.iterator__sc_Iterator();
    var i$6 = 0;
    while (iterator$6.hasNext__Z()) {
      array.u[i$6] = iterator$6.next__O();
      i$6 = ((1 + i$6) | 0);
    }
    var elements$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(0);
    var iterator$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    var i$7 = 0;
    while ((i$7 < 0)) {
      elements$6.u[i$7] = iterator$7.next__O();
      i$7 = ((1 + i$7) | 0);
    }
    var xs$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var len$1 = xs$1.length__I();
    var array$1 = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)(len$1);
    var iterator$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    var i$8 = 0;
    while (iterator$8.hasNext__Z()) {
      array$1.u[i$8] = iterator$8.next__O();
      i$8 = ((1 + i$8) | 0);
    }
    var elements$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(0);
    var iterator$9 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
    var i$9 = 0;
    while ((i$9 < 0)) {
      elements$7.u[i$9] = iterator$9.next__O();
      i$9 = ((1 + i$9) | 0);
    }
    var sealedTrait = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_SealedTrait(typeInfo, array, elements$6, array$1, true, elements$7);
    this.Lapp_data_GeneralPracticeUserOutOfOffice$__f_derived$Schema$lzy1 = derivation.split__Lmagnolia1_SealedTrait__Lsttp_tapir_Schema(sealedTrait);
    this.Lapp_data_GeneralPracticeUserOutOfOffice$__f_derived$Schemabitmap$1 = true;
  }
  return this.Lapp_data_GeneralPracticeUserOutOfOffice$__f_derived$Schema$lzy1;
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$.prototype.derived$CirceCodec__Lio_circe_Codec = (function() {
  if ((!this.Lapp_data_GeneralPracticeUserOutOfOffice$__f_derived$CirceCodecbitmap$1)) {
    var configuration$proxy1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().Lio_circe_derivation_Configuration$__f_default;
    var decoders$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var f$proxy1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_DecoderDeriveSum(configuration$proxy1);
      var x$2$proxy1 = f$proxy1.Lio_circe_derivation_DecoderDeriveSum__f_x$1;
      var m = $s_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite__Lapp_data_GeneralPracticeUserOutOfOffice();
      var decoders = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
      var labels = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var fromProduct = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((p) => m))));
      var values = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_T$package$EmptyTuple$()));
      var defaults = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_Default$$anon$1(values);
      var elem$21 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_ConfiguredDecoder$$anon$3(x$2$proxy1, "Indefinite", fromProduct, decoders, labels, defaults);
      var x$2$proxy2 = f$proxy1.Lio_circe_derivation_DecoderDeriveSum__f_x$1;
      var m$3 = $m_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$();
      var decoders$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
        var f$proxy3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_DecoderNotDeriveSum(x$2$proxy2);
        var decodeA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_data_FrameworkDate$().circeCodec__Lio_circe_Codec();
        var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(decodeA, this$5);
      }));
      var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var labels$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("endsAt", this$6);
      var fromProduct$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((p$1) => m$3.fromProduct__s_Product__Lapp_data_GeneralPracticeUserOutOfOffice$Finite(p$1)))));
      var values$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
        var _1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T1(_1);
      }));
      var defaults$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_Default$$anon$1(values$1);
      var elem$21$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_ConfiguredDecoder$$anon$3(x$2$proxy2, "Finite", fromProduct$1, decoders$1, labels$1, defaults$1);
      var this$10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var this$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$21$3, this$10);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$21, this$11);
    }));
    var encoders$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var f$proxy4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_EncoderDeriveSum(configuration$proxy1);
      var x$2$proxy4 = f$proxy4.Lio_circe_derivation_EncoderDeriveSum__f_config;
      $s_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite__Lapp_data_GeneralPracticeUserOutOfOffice();
      var encoders = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()));
      var labels$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var elem$21$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_ConfiguredEncoder$$anon$3(x$2$proxy4, encoders, labels$2);
      var x$2$proxy5 = f$proxy4.Lio_circe_derivation_EncoderDeriveSum__f_config;
      var encoders$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
        var f$proxy6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_EncoderNotDeriveSum(x$2$proxy5);
        var encodeA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_data_FrameworkDate$().circeCodec__Lio_circe_Codec();
        var this$13 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
        return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(encodeA, this$13);
      }));
      var this$14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var labels$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("endsAt", this$14);
      var elem$21$3$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_ConfiguredEncoder$$anon$3(x$2$proxy5, encoders$1, labels$3);
      var this$16 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      var this$17 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$21$3$1, this$16);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$21$1, this$17);
    }));
    var this$18 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    var this$19 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("Finite", this$18);
    var labels$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("Indefinite", this$19);
    var ordinal = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      $m_Lapp_data_GeneralPracticeUserOutOfOffice$();
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x) => x.ordinal__I()));
    }));
    var values$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var _1$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      var _2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1$1, _2);
    }));
    var defaults$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_Default$$anon$1(values$2);
    this.Lapp_data_GeneralPracticeUserOutOfOffice$__f_derived$CirceCodec$lzy1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_derivation_ConfiguredCodec$$anon$4(configuration$proxy1, "GeneralPracticeUserOutOfOffice", ordinal, decoders$2, encoders$2, labels$4, defaults$2);
    this.Lapp_data_GeneralPracticeUserOutOfOffice$__f_derived$CirceCodecbitmap$1 = true;
  }
  return this.Lapp_data_GeneralPracticeUserOutOfOffice$__f_derived$CirceCodec$lzy1;
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$.prototype.ordinal__O__I = (function(x) {
  return x.ordinal__I();
});
var $d_Lapp_data_GeneralPracticeUserOutOfOffice$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserOutOfOffice$, "app.data.GeneralPracticeUserOutOfOffice$", ({
  Lapp_data_GeneralPracticeUserOutOfOffice$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lapp_data_GeneralPracticeUserOutOfOffice$ as $d_Lapp_data_GeneralPracticeUserOutOfOffice$ };
var $n_Lapp_data_GeneralPracticeUserOutOfOffice$;
function $m_Lapp_data_GeneralPracticeUserOutOfOffice$() {
  if ((!$n_Lapp_data_GeneralPracticeUserOutOfOffice$)) {
    $n_Lapp_data_GeneralPracticeUserOutOfOffice$ = new $c_Lapp_data_GeneralPracticeUserOutOfOffice$();
  }
  return $n_Lapp_data_GeneralPracticeUserOutOfOffice$;
}
export { $m_Lapp_data_GeneralPracticeUserOutOfOffice$ as $m_Lapp_data_GeneralPracticeUserOutOfOffice$ };
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$() {
}
export { $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$ as $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$ };
$c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$.prototype.constructor = $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$() {
}
export { $h_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$ as $h_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$ };
$h_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$.prototype = $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$.prototype;
$c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$.prototype.toString__T = (function() {
  return "Finite";
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$.prototype.fromProduct__s_Product__Lapp_data_GeneralPracticeUserOutOfOffice$Finite = (function(x$0) {
  var ev$6 = x$0.productElement__I__O(0);
  var endsAt$1 = ((ev$6 === null) ? null : ev$6.Lframework_data_FrameworkDate__f_ld);
  return new $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite(endsAt$1);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_data_GeneralPracticeUserOutOfOffice$Finite(p);
});
var $d_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$, "app.data.GeneralPracticeUserOutOfOffice$Finite$", ({
  Lapp_data_GeneralPracticeUserOutOfOffice$Finite$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$ as $d_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$ };
var $n_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$;
function $m_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$() {
  if ((!$n_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$)) {
    $n_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$ = new $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$();
  }
  return $n_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$;
}
export { $m_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$ as $m_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$ };
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10() {
}
export { $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10 as $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10 };
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10.prototype.constructor = $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10() {
}
export { $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10 as $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10 };
$h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10.prototype = $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10.prototype;
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__andThen__F1__F1(this, g);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10.prototype.apply__Lapp_data_GeneralPracticeUserOutOfOffice__Z = (function(a) {
  return ((a === $s_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite__Lapp_data_GeneralPracticeUserOutOfOffice()) && (a !== null));
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10.prototype.apply__O__O = (function(v1) {
  return this.apply__Lapp_data_GeneralPracticeUserOutOfOffice__Z(v1);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return this.apply__Lapp_data_GeneralPracticeUserOutOfOffice__Z(v1);
});
var $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10, "app.data.GeneralPracticeUserOutOfOffice$$anon$10", ({
  Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10: 1,
  F1: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction1: 1
}));
export { $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10 as $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$10 };
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12(SealedTraitDerivation_this$4) {
  this.Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12__f_SealedTraitDerivation_this$2 = null;
  this.Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12__f_SealedTraitDerivation_this$2 = SealedTraitDerivation_this$4;
}
export { $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12 as $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12 };
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12.prototype.constructor = $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12() {
}
export { $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12 as $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12 };
$h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12.prototype = $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12.prototype;
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12.prototype.apply__Lsttp_tapir_Schema = (function() {
  var Derivation_this = this.Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12__f_SealedTraitDerivation_this$2;
  var m$proxy3 = $m_Lapp_data_GeneralPracticeUserOutOfOffice$Finite$();
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var factory = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var factory$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory);
  var annotations$proxy2 = factory$1.fromSpecific__sc_IterableOnce__O(this$2);
  var _2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "endsAt", _2), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
  var factory$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var factory$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$2);
  var inheritedAnnotations$proxy2 = factory$3.fromSpecific__sc_IterableOnce__O(this$5);
  var this$7 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var factory$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var factory$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$4);
  var typeAnnotations$proxy2 = factory$5.fromSpecific__sc_IterableOnce__O(this$7);
  var this$10 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "endsAt", false), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
  var factory$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var factory$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$6);
  var repeated$proxy2 = factory$7.fromSpecific__sc_IterableOnce__O(this$10);
  var _2$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  var this$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "endsAt", _2$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
  var factory$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var factory$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$8);
  var defaults$proxy2 = factory$9.fromSpecific__sc_IterableOnce__O(this$13);
  var tc = new $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dOut$002dOf$002dOffice$0024$0024anon$002413.$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$13();
  matchResult27: {
    var d;
    var $x_1 = defaults$proxy2.get__O__s_Option("endsAt");
    var this$14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
    var x97 = $x_1.flatten__s_$less$colon$less__s_Option(this$14.s_$less$colon$less$__f_singleton);
    if ((x97 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
      var evaluator = x97.s_Some__f_value;
      var d = new $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dOut$002dOf$002dOffice$0024$0024anon$002414.$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$14(evaluator);
      break matchResult27;
    }
    var d = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CaseClassDerivation$().Lmagnolia1_CaseClassDerivation$__f_returningNone;
  }
  var this$15 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CaseClassDerivation$();
  var tc$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CallByNeed$().createLazy__F0__Lmagnolia1_CallByNeed(tc);
  var d$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lmagnolia1_CallByNeed$().createValueEvaluator__F0__Lmagnolia1_CallByNeed(d);
  var elem$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param(this$15, "endsAt", tc$1, d$1, repeated$proxy2, annotations$proxy2, inheritedAnnotations$proxy2, typeAnnotations$proxy2, 0);
  var this$16 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var xs = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(elem$1, this$16);
  var len = xs.length__I();
  var array = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lmagnolia1_CaseClass$Param.getArrayOf().constr)(len);
  var iterator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_StrictOptimizedLinearSeqOps$$anon$1(xs);
  var i = 0;
  while (iterator.hasNext__Z()) {
    array.u[i] = iterator.next__O();
    i = ((1 + i) | 0);
  }
  var typeParams = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var $x_2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lmagnolia1_TypeInfo("app.data.GeneralPracticeUserOutOfOffice", "Finite", typeParams);
  var xs$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var len$1 = xs$1.length__I();
  var array$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(len$1);
  var iterator$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$1 = 0;
  while (iterator$1.hasNext__Z()) {
    array$1.u[i$1] = iterator$1.next__O();
    i$1 = ((1 + i$1) | 0);
  }
  var xs$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var len$2 = xs$2.length__I();
  var array$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(len$2);
  var iterator$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$2 = 0;
  while (iterator$2.hasNext__Z()) {
    array$2.u[i$2] = iterator$2.next__O();
    i$2 = ((1 + i$2) | 0);
  }
  var xs$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var len$3 = xs$3.length__I();
  var array$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(len$3);
  var iterator$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$3 = 0;
  while (iterator$3.hasNext__Z()) {
    array$3.u[i$3] = iterator$3.next__O();
    i$3 = ((1 + i$3) | 0);
  }
  return Derivation_this.join__Lmagnolia1_CaseClass__Lsttp_tapir_Schema(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lmagnolia1_CaseClassDerivation$ProductCaseClass($x_2, false, false, array, array$1, array$2, array$3, m$proxy3));
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12.prototype.apply__O = (function() {
  return this.apply__Lsttp_tapir_Schema();
});
var $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12, "app.data.GeneralPracticeUserOutOfOffice$$anon$12", ({
  Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12 as $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$12 };
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15() {
}
export { $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15 as $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15 };
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15.prototype.constructor = $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15() {
}
export { $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15 as $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15 };
$h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15.prototype = $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15.prototype;
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__andThen__F1__F1(this, g);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15.prototype.apply__Lapp_data_GeneralPracticeUserOutOfOffice__Z = (function(a) {
  return ((a instanceof $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite) && (a !== null));
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15.prototype.apply__O__O = (function(v1) {
  return this.apply__Lapp_data_GeneralPracticeUserOutOfOffice__Z(v1);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return this.apply__Lapp_data_GeneralPracticeUserOutOfOffice__Z(v1);
});
var $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15, "app.data.GeneralPracticeUserOutOfOffice$$anon$15", ({
  Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15: 1,
  F1: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction1: 1
}));
export { $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15 as $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$15 };
function $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct($thiz, ctx) {
  var $x_10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$();
  var arr = ctx.Lmagnolia1_CaseClass__f_parameters;
  var f = ((p) => {
    var annotations = $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq($thiz, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(p.Lmagnolia1_CaseClass$Param$$anon$2__f_annotations), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(p.Lmagnolia1_CaseClass$Param$$anon$2__f_inheritedAnns$4));
    var pSchema = $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema($thiz, p.typeclass__O(), annotations);
    var this$2 = annotations.collectFirst__s_PartialFunction__s_Option(new $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dOut$002dOf$002dOffice$0024$0024anon$00248.$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$8());
    var encodedName = (this$2.isEmpty__Z() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_Configuration$().Lsttp_tapir_generic_Configuration$__f_default.Lsttp_tapir_generic_Configuration__f_toEncodedName.apply__O__O(p.Lmagnolia1_CaseClass$Param$$anon$2__f_label) : this$2.get__O());
    var name = p.Lmagnolia1_CaseClass$Param$$anon$2__f_label;
    var _name = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_FieldName(name, encodedName);
    var _get = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((p$3) => ((t) => {
      var value = p$3.deref__O__O(t);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    }))(p));
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SProductField$$anon$1(_name, pSchema, _get);
  });
  var len = arr.u.length;
  var ys = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lsttp_tapir_SchemaType$SProductField.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((arr !== null)) {
      while ((i < len)) {
        var $x_1 = i;
        var x0 = arr.u[i];
        ys.u[$x_1] = f(x0);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I)) {
      while ((i < len)) {
        var $x_2 = i;
        var x0$1 = arr.u[i];
        ys.u[$x_2] = f(x0$1);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_D)) {
      while ((i < len)) {
        var $x_3 = i;
        var x0$2 = arr.u[i];
        ys.u[$x_3] = f(x0$2);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J)) {
      while ((i < len)) {
        var $x_4 = i;
        var t$1 = arr.u[i];
        var lo = t$1.RTLong__f_lo;
        var hi = t$1.RTLong__f_hi;
        ys.u[$x_4] = f(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_F)) {
      while ((i < len)) {
        var $x_5 = i;
        var x0$3 = arr.u[i];
        ys.u[$x_5] = f(x0$3);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_C)) {
      while ((i < len)) {
        var $x_6 = i;
        var x0$4 = arr.u[i];
        ys.u[$x_6] = f($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(x0$4));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B)) {
      while ((i < len)) {
        var $x_7 = i;
        var x0$5 = arr.u[i];
        ys.u[$x_7] = f(x0$5);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_S)) {
      while ((i < len)) {
        var $x_8 = i;
        var x0$6 = arr.u[i];
        ys.u[$x_8] = f(x0$6);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_Z)) {
      while ((i < len)) {
        var $x_9 = i;
        var x0$7 = arr.u[i];
        ys.u[$x_9] = f(x0$7);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(arr);
    }
  }
  var this$11 = $x_10.wrapRefArray__AO__sci_ArraySeq$ofRef(ys);
  var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$11);
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SProduct(fields);
}
export { $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct as $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct };
function $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName($thiz, typeName, annotations) {
  var x56 = annotations.collectFirst__s_PartialFunction__s_Option(new $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dOut$002dOf$002dOffice$0024$0024anon$00247.$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$7());
  if ((x56 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var altName = x56.s_Some__f_value;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$SName$();
    var typeParameterShortNames = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema$SName(altName, typeParameterShortNames);
  }
  var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  if ((x === x56)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$SName$();
    var fullName = typeName.full__T();
    var typeParameterShortNames$1 = $s_Lapp_data_GeneralPracticeUserOutOfOffice$__app$data$GeneralPracticeUserOutOfOffice$$anon$6$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq(typeName).map__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => _$1.full__T()))).toList__sci_List();
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema$SName(fullName, typeParameterShortNames$1);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x56);
}
export { $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName as $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName };
function $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__subtypeNameToSchemaName__Lmagnolia1_SealedTrait$Subtype__Lsttp_tapir_Schema$SName($thiz, subtype) {
  return $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName($thiz, subtype.Lmagnolia1_SealedTrait$Subtype__f_typeInfo, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(subtype.Lmagnolia1_SealedTrait$Subtype__f_annotations));
}
export { $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__subtypeNameToSchemaName__Lmagnolia1_SealedTrait$Subtype__Lsttp_tapir_Schema$SName as $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__subtypeNameToSchemaName__Lmagnolia1_SealedTrait$Subtype__Lsttp_tapir_Schema$SName };
function $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema($thiz, schema, annotations) {
  return annotations.foldLeft__O__F2__O(schema, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((x$1, x$2) => {
    if (false) {
      return x$1.description__T__Lsttp_tapir_Schema(x$2.text__T());
    } else if (false) {
      return x$1.encodedExample__O__Lsttp_tapir_Schema(x$2.example__O());
    } else if (false) {
      return x$1.default__O__s_Option__Lsttp_tapir_Schema(x$2.default__O(), x$2.encoded__s_Option());
    } else if (false) {
      return x$1.validate__Lsttp_tapir_Validator__Lsttp_tapir_Schema(x$2.v__Lsttp_tapir_Validator());
    } else if (false) {
      var fields = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_ModifyCollectionElements]));
      var modify = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((ann$6) => ((_$2) => _$2.validate__Lsttp_tapir_Validator__Lsttp_tapir_Schema(ann$6.v__Lsttp_tapir_Validator())))(x$2));
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$p_Lsttp_tapir_Schema__modifyAtPath__sci_List__F1__Lsttp_tapir_Schema(x$1, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(fields), modify);
    } else if (false) {
      return x$1.format__T__Lsttp_tapir_Schema(x$2.format__T());
    } else if (false) {
      return x$1.title__T__Lsttp_tapir_Schema(x$2.name__T());
    } else if (false) {
      var schemaType = x$1.Lsttp_tapir_Schema__f_schemaType;
      var name = x$1.Lsttp_tapir_Schema__f_name;
      var isOptional = x$1.Lsttp_tapir_Schema__f_isOptional;
      var description = x$1.Lsttp_tapir_Schema__f_description;
      var default$1 = x$1.Lsttp_tapir_Schema__f_default;
      var format = x$1.Lsttp_tapir_Schema__f_format;
      var encodedExample = x$1.Lsttp_tapir_Schema__f_encodedExample;
      var hidden = x$1.Lsttp_tapir_Schema__f_hidden;
      var validator = x$1.Lsttp_tapir_Schema__f_validator;
      var attributes = x$1.Lsttp_tapir_Schema__f_attributes;
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, true, hidden, validator, attributes);
    } else {
      return (false ? x$2.f__F1().apply__O__O(x$1) : x$1);
    }
  })));
}
export { $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema as $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema };
function $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq($thiz, primary, inherited) {
  var suffix = inherited.distinct__O().filter__F1__O(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => (!primary.exists__F1__Z(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => {
    var this$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass(_$3);
    var that = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass(x$1);
    return (this$1 === that);
  })))))));
  return primary.appendedAll__sc_IterableOnce__O(suffix);
}
export { $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq as $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq };
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6(SchemaMagnoliaDerivation_this$2) {
  this.Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__f_SchemaMagnoliaDerivation_this$1 = null;
  this.Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__f_SchemaMagnoliaDerivation_this$1 = SchemaMagnoliaDerivation_this$2;
}
export { $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6 as $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6 };
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6.prototype.constructor = $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6() {
}
export { $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6 as $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6 };
$h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6.prototype = $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6.prototype;
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6.prototype.join__Lmagnolia1_CaseClass__Lsttp_tapir_Schema = (function(ctx) {
  var typeName = ctx.Lmagnolia1_CaseClass__f_typeInfo;
  var annotations = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations);
  var cacheKey = typeName.full__T();
  var inProgressOrNull = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.get__O();
  var newCache = (inProgressOrNull === null);
  if (newCache) {
    var newInProgress = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Set$().apply__sci_Seq__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)([])));
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.set__O__V(newInProgress);
    var inProgress = newInProgress;
  } else {
    if ((inProgressOrNull === null)) {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Scala3RunTime$().nnFail__E();
    }
    var inProgress = inProgressOrNull;
  }
  if (inProgress.contains__O__Z(cacheKey)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var name = $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, typeName, annotations);
    var schemaType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SRef(name);
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var name$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var isOptional = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var format = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var encodedExample = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var deprecated = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var hidden = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name$1, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  } else {
    try {
      inProgress.add__O__Z(cacheKey);
      if (ctx.Lmagnolia1_CaseClass__f_isValueClass) {
        var requirement = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().nonEmpty__O__Z(ctx.Lmagnolia1_CaseClass__f_parameters);
        if ((!requirement)) {
          throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (("requirement failed: " + "Cannot derive schema for generic value class: ") + ctx.Lmagnolia1_CaseClass__f_typeInfo.Lmagnolia1_TypeInfo__f_owner));
        }
        var valueSchema = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().head__O__O(ctx.Lmagnolia1_CaseClass__f_parameters).typeclass__O();
        var schemaType$1 = valueSchema.Lsttp_tapir_Schema__f_schemaType;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var name$1$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var isOptional$1 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var description$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var default$1$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var encodedExample$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var deprecated$1 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var hidden$1 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var validator$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var attributes$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var format$1 = valueSchema.Lsttp_tapir_Schema__f_format;
        var result = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType$1, name$1$1, isOptional$1, description$1, default$1$1, format$1, encodedExample$1, deprecated$1, hidden$1, validator$1, attributes$1);
      } else {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var schemaType$2 = $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct(this, ctx);
        var value = $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, ctx.Lmagnolia1_CaseClass__f_typeInfo, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations));
        var name$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var isOptional$2 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var description$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var default$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var format$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var encodedExample$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var deprecated$2 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var hidden$2 = false;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var validator$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
        var attributes$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
        var result = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType$2, name$2, isOptional$2, description$2, default$2, format$2, encodedExample$2, deprecated$2, hidden$2, validator$2, attributes$2);
      }
      var this$28 = ctx.Lmagnolia1_CaseClass__f_typeInfo.full__T();
      if ((!(!this$28.startsWith("scala.Tuple")))) {
        result = result.tuple__Lsttp_tapir_Schema();
      }
      var schema = $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema(this, result, $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq(this, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_inheritedAnnotations)));
      return schema;
    } finally {
      inProgress.remove__O__Z(cacheKey);
      if (newCache) {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.remove__V();
      }
    }
  }
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6.prototype.split__Lmagnolia1_SealedTrait__Lsttp_tapir_Schema = (function(ctx) {
  var typeName = ctx.Lmagnolia1_SealedTrait__f_typeInfo;
  var annotations = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_SealedTrait__f_annotations);
  var cacheKey = typeName.full__T();
  var inProgressOrNull = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.get__O();
  var newCache = (inProgressOrNull === null);
  if (newCache) {
    var newInProgress = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_Set$().apply__sci_Seq__O($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)([])));
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.set__O__V(newInProgress);
    var inProgress = newInProgress;
  } else {
    if ((inProgressOrNull === null)) {
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Scala3RunTime$().nnFail__E();
    }
    var inProgress = inProgressOrNull;
  }
  if (inProgress.contains__O__Z(cacheKey)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var name = $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, typeName, annotations);
    var schemaType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SRef(name);
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var name$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var isOptional = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var format = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var encodedExample = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var deprecated = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var hidden = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name$1, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  } else {
    try {
      inProgress.add__O__Z(cacheKey);
      var this$12 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().wrapRefArray__AO__sci_ArraySeq$ofRef(ctx.Lmagnolia1_SealedTrait__f_subtypes);
      var this$17 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$12);
      var f = ((s) => {
        var self = $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, s.Lmagnolia1_SealedTrait$Subtype__f_typeInfo, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(s.Lmagnolia1_SealedTrait$Subtype__f_annotations));
        var y = s.typeclass__O();
        return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self, y);
      });
      if ((this$17 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
        var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
      } else {
        var x0 = this$17.head__O();
        var h = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
        var t = h;
        var rest = this$17.tail__O();
        while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
          var x0$1 = rest.head__O();
          var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(f(x0$1), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
          t.sci_$colon$colon__f_next = nx;
          t = nx;
          rest = rest.tail__O();
        }
        var xs = h;
      }
      var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_internal_package$IterableToListMap(xs);
      var this$19 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
      var subtypesByName = $x_1.toListMap__s_$less$colon$less__sci_ListMap(this$19.s_$less$colon$less$__f_singleton);
      var this$20 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapOps$$anon$1(subtypesByName);
      var subtypes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$20);
      var discriminator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      var subtypeSchema = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((t$1) => {
        var ix$tailLocal1 = 0;
        while (true) {
          var $x_2 = ix$tailLocal1;
          var arr = ctx.Lmagnolia1_SealedTrait__f_subtypes;
          if (($x_2 >= arr.u.length)) {
            throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalArgumentException(), (((("The given value `" + t$1) + "` is not a sub type of `") + ctx.Lmagnolia1_SealedTrait__f_typeInfo) + "`"));
          }
          var arr$1 = ctx.Lmagnolia1_SealedTrait__f_subtypes;
          var n = ix$tailLocal1;
          var sub = arr$1.u[n];
          if ((!sub.isDefinedAt__O__Z(t$1))) {
            ix$tailLocal1 = ((1 + ix$tailLocal1) | 0);
            continue;
          }
          var x0$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lmagnolia1_SealedTrait$SubtypeValue(sub, t$1);
          var this$24 = subtypesByName.get__O__s_Option($p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__subtypeNameToSchemaName__Lmagnolia1_SealedTrait$Subtype__Lsttp_tapir_Schema$SName(this, x0$2.Lmagnolia1_SealedTrait$SubtypeValue__f_subtype));
          if (this$24.isEmpty__Z()) {
            return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          } else {
            var x0$3 = this$24.get__O();
            var value = x0$2.value__O();
            return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_SchemaType$SchemaWithValue(x0$3, value));
          }
        }
      }));
      var baseCoproduct = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SCoproduct(subtypes, discriminator, subtypeSchema);
      matchResult25: {
        var coproduct;
        var x93 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_Configuration$().Lsttp_tapir_generic_Configuration$__f_default.Lsttp_tapir_generic_Configuration__f_discriminator;
        if ((x93 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
          var d = x93.s_Some__f_value;
          var $x_12 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$();
          var arr$2 = ctx.Lmagnolia1_SealedTrait__f_subtypes;
          var f$1 = ((s$2) => {
            var schemaName = $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__subtypeNameToSchemaName__Lmagnolia1_SealedTrait$Subtype__Lsttp_tapir_Schema$SName(this, s$2);
            var self$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_Configuration$().Lsttp_tapir_generic_Configuration$__f_default.Lsttp_tapir_generic_Configuration__f_toDiscriminatorValue.apply__O__O(schemaName);
            var y$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SRef(schemaName);
            return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), self$1, y$1);
          });
          var len = arr$2.u.length;
          var ys = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.getArrayOf().constr)(len);
          if ((len > 0)) {
            var i = 0;
            if ((arr$2 !== null)) {
              while ((i < len)) {
                var $x_3 = i;
                var x0$4 = arr$2.u[i];
                ys.u[$x_3] = f$1(x0$4);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I)) {
              while ((i < len)) {
                var $x_4 = i;
                var x0$5 = arr$2.u[i];
                ys.u[$x_4] = f$1(x0$5);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_D)) {
              while ((i < len)) {
                var $x_5 = i;
                var x0$6 = arr$2.u[i];
                ys.u[$x_5] = f$1(x0$6);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J)) {
              while ((i < len)) {
                var $x_6 = i;
                var t$2 = arr$2.u[i];
                var lo = t$2.RTLong__f_lo;
                var hi = t$2.RTLong__f_hi;
                ys.u[$x_6] = f$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_F)) {
              while ((i < len)) {
                var $x_7 = i;
                var x0$7 = arr$2.u[i];
                ys.u[$x_7] = f$1(x0$7);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_C)) {
              while ((i < len)) {
                var $x_8 = i;
                var x0$8 = arr$2.u[i];
                ys.u[$x_8] = f$1($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(x0$8));
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B)) {
              while ((i < len)) {
                var $x_9 = i;
                var x0$9 = arr$2.u[i];
                ys.u[$x_9] = f$1(x0$9);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_S)) {
              while ((i < len)) {
                var $x_10 = i;
                var x0$10 = arr$2.u[i];
                ys.u[$x_10] = f$1(x0$10);
                i = ((1 + i) | 0);
              }
            } else if ((arr$2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_Z)) {
              while ((i < len)) {
                var $x_11 = i;
                var x0$11 = arr$2.u[i];
                ys.u[$x_11] = f$1(x0$11);
                i = ((1 + i) | 0);
              }
            } else {
              throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(arr$2);
            }
          }
          var this$36 = $x_12.wrapRefArray__AO__sci_ArraySeq$ofRef(ys);
          var discriminatorMapping = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$().from__sc_IterableOnce__sci_Map(this$36);
          var discriminatorName$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_FieldName(d, d);
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var schemaType$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SString();
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var name$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var isOptional$1 = false;
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var description$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var default$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var format$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var encodedExample$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var deprecated$1 = false;
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var hidden$1 = false;
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var validator$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
          $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
          var attributes$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
          var discriminatorSchema$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType$1, name$2, isOptional$1, description$1, default$2, format$1, encodedExample$1, deprecated$1, hidden$1, validator$1, attributes$1);
          var coproduct = baseCoproduct.addDiscriminatorField__Lsttp_tapir_FieldName__Lsttp_tapir_Schema__sci_Map__Lsttp_tapir_SchemaType$SCoproduct(discriminatorName$1, discriminatorSchema$1, discriminatorMapping);
          break matchResult25;
        }
        var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
        if ((x === x93)) {
          var coproduct = baseCoproduct;
          break matchResult25;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x93);
      }
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var value$1 = $p_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, ctx.Lmagnolia1_SealedTrait__f_typeInfo, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_SealedTrait__f_annotations));
      var name$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value$1);
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var isOptional$2 = false;
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var description$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var default$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var format$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var encodedExample$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var deprecated$2 = false;
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var hidden$2 = false;
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var validator$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
      $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
      var attributes$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
      var schema = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(coproduct, name$3, isOptional$2, description$2, default$3, format$2, encodedExample$2, deprecated$2, hidden$2, validator$2, attributes$2);
      return schema;
    } finally {
      inProgress.remove__O__Z(cacheKey);
      if (newCache) {
        $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.remove__V();
      }
    }
  }
});
var $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6, "app.data.GeneralPracticeUserOutOfOffice$$anon$6", ({
  Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6: 1,
  Lmagnolia1_CommonDerivation: 1,
  Lmagnolia1_SealedTraitDerivation: 1,
  Lmagnolia1_Derivation: 1
}));
export { $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6 as $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$6 };
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9(SealedTraitDerivation_this$3) {
  this.Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9__f_SealedTraitDerivation_this$1 = null;
  this.Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9__f_SealedTraitDerivation_this$1 = SealedTraitDerivation_this$3;
}
export { $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9 as $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9 };
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9.prototype.constructor = $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9() {
}
export { $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9 as $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9 };
$h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9.prototype = $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9.prototype;
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9.prototype.apply__Lsttp_tapir_Schema = (function() {
  var Derivation_this = this.Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9__f_SealedTraitDerivation_this$1;
  var m$proxy2 = $s_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite__Lapp_data_GeneralPracticeUserOutOfOffice();
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var factory = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var factory$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory);
  factory$1.fromSpecific__sc_IterableOnce__O(this$2);
  var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var factory$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var factory$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$2);
  factory$3.fromSpecific__sc_IterableOnce__O(this$4);
  var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var factory$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var factory$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$4);
  factory$5.fromSpecific__sc_IterableOnce__O(this$6);
  var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var factory$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var factory$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$6);
  factory$7.fromSpecific__sc_IterableOnce__O(this$8);
  var this$10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var factory$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var factory$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$8);
  factory$9.fromSpecific__sc_IterableOnce__O(this$10);
  var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var len = xs.length__I();
  var array = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lmagnolia1_CaseClass$Param.getArrayOf().constr)(len);
  var iterator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i = 0;
  while (iterator.hasNext__Z()) {
    array.u[i] = iterator.next__O();
    i = ((1 + i) | 0);
  }
  var typeParams = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lmagnolia1_TypeInfo("app.data", "Indefinite", typeParams);
  var xs$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var len$1 = xs$1.length__I();
  var array$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(len$1);
  var iterator$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$1 = 0;
  while (iterator$1.hasNext__Z()) {
    array$1.u[i$1] = iterator$1.next__O();
    i$1 = ((1 + i$1) | 0);
  }
  var xs$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var len$2 = xs$2.length__I();
  var array$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(len$2);
  var iterator$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$2 = 0;
  while (iterator$2.hasNext__Z()) {
    array$2.u[i$2] = iterator$2.next__O();
    i$2 = ((1 + i$2) | 0);
  }
  var xs$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var len$3 = xs$3.length__I();
  var array$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(len$3);
  var iterator$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$3 = 0;
  while (iterator$3.hasNext__Z()) {
    array$3.u[i$3] = iterator$3.next__O();
    i$3 = ((1 + i$3) | 0);
  }
  return Derivation_this.join__Lmagnolia1_CaseClass__Lsttp_tapir_Schema(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lmagnolia1_CaseClassDerivation$ProductCaseClass($x_1, false, false, array, array$1, array$2, array$3, m$proxy2));
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9.prototype.apply__O = (function() {
  return this.apply__Lsttp_tapir_Schema();
});
var $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9, "app.data.GeneralPracticeUserOutOfOffice$$anon$9", ({
  Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9 as $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$9 };
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserOutOfOffice() {
}
export { $c_Lapp_data_GeneralPracticeUserOutOfOffice as $c_Lapp_data_GeneralPracticeUserOutOfOffice };
$c_Lapp_data_GeneralPracticeUserOutOfOffice.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserOutOfOffice.prototype.constructor = $c_Lapp_data_GeneralPracticeUserOutOfOffice;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserOutOfOffice() {
}
export { $h_Lapp_data_GeneralPracticeUserOutOfOffice as $h_Lapp_data_GeneralPracticeUserOutOfOffice };
$h_Lapp_data_GeneralPracticeUserOutOfOffice.prototype = $c_Lapp_data_GeneralPracticeUserOutOfOffice.prototype;
$c_Lapp_data_GeneralPracticeUserOutOfOffice.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice.prototype.validated__Ljava_time_LocalDate__s_Option = (function(now) {
  if ((this instanceof $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite)) {
    var x24 = this.Lapp_data_GeneralPracticeUserOutOfOffice$Finite__f_endsAt;
    var this$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(now);
    var that = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(x24);
    if ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_s_math_Ordered__$greater__O__Z(this$2, that)) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    }
  }
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(this);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice.prototype.isFinite__Z = (function() {
  var x = $s_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite__Lapp_data_GeneralPracticeUserOutOfOffice();
  if (((x !== null) && x.equals__O__Z(this))) {
    return false;
  }
  if ((this instanceof $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite)) {
    return true;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice.prototype.asOption__s_Option = (function() {
  var x = $s_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite__Lapp_data_GeneralPracticeUserOutOfOffice();
  if (((x !== null) && x.equals__O__Z(this))) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  if ((this instanceof $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite)) {
    var x32 = this.Lapp_data_GeneralPracticeUserOutOfOffice$Finite__f_endsAt;
    var value = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(x32);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
});
function $isArrayOf_Lapp_data_GeneralPracticeUserOutOfOffice(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_GeneralPracticeUserOutOfOffice)));
}
export { $isArrayOf_Lapp_data_GeneralPracticeUserOutOfOffice as $isArrayOf_Lapp_data_GeneralPracticeUserOutOfOffice };
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite(endsAt) {
  this.Lapp_data_GeneralPracticeUserOutOfOffice$Finite__f_endsAt = null;
  this.Lapp_data_GeneralPracticeUserOutOfOffice$Finite__f_endsAt = endsAt;
}
export { $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite as $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite };
$c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite.prototype = new $h_Lapp_data_GeneralPracticeUserOutOfOffice();
$c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite.prototype.constructor = $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserOutOfOffice$Finite() {
}
export { $h_Lapp_data_GeneralPracticeUserOutOfOffice$Finite as $h_Lapp_data_GeneralPracticeUserOutOfOffice$Finite };
$h_Lapp_data_GeneralPracticeUserOutOfOffice$Finite.prototype = $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite.prototype;
$c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-470815741), true);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite)) {
    var x = this.Lapp_data_GeneralPracticeUserOutOfOffice$Finite__f_endsAt;
    var x$2 = x$0.Lapp_data_GeneralPracticeUserOutOfOffice$Finite__f_endsAt;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite.prototype.productPrefix__T = (function() {
  return "Finite";
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite.prototype.productElement__I__O = (function(n) {
  matchResult12: {
    var $x_1;
    if ((n === 0)) {
      var $x_1 = this.Lapp_data_GeneralPracticeUserOutOfOffice$Finite__f_endsAt;
      break matchResult12;
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate($x_1);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "endsAt";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite.prototype.ordinal__I = (function() {
  return 1;
});
function $isArrayOf_Lapp_data_GeneralPracticeUserOutOfOffice$Finite(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_GeneralPracticeUserOutOfOffice$Finite)));
}
export { $isArrayOf_Lapp_data_GeneralPracticeUserOutOfOffice$Finite as $isArrayOf_Lapp_data_GeneralPracticeUserOutOfOffice$Finite };
var $d_Lapp_data_GeneralPracticeUserOutOfOffice$Finite = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserOutOfOffice$Finite, "app.data.GeneralPracticeUserOutOfOffice$Finite", ({
  Lapp_data_GeneralPracticeUserOutOfOffice$Finite: 1,
  Lapp_data_GeneralPracticeUserOutOfOffice: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_data_GeneralPracticeUserOutOfOffice$Finite as $d_Lapp_data_GeneralPracticeUserOutOfOffice$Finite };
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3(\u03b4name$6, _$ordinal$6) {
  this.Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3__f_$name$3 = null;
  this.Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3__f__$ordinal$3 = 0;
  this.Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3__f_$name$3 = \u03b4name$6;
  this.Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3__f__$ordinal$3 = _$ordinal$6;
}
export { $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3 as $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3 };
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3.prototype = new $h_Lapp_data_GeneralPracticeUserOutOfOffice();
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3.prototype.constructor = $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3() {
}
export { $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3 as $h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3 };
$h_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3.prototype = $c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3.prototype;
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3.prototype.productPrefix__T = (function() {
  return this.Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3__f_$name$3;
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3.prototype.toString__T = (function() {
  return this.Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3__f_$name$3;
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3.prototype.ordinal__I = (function() {
  return this.Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3__f__$ordinal$3;
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3__f_$name$3);
});
$c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3, "app.data.GeneralPracticeUserOutOfOffice$$anon$3", ({
  Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3: 1,
  Lapp_data_GeneralPracticeUserOutOfOffice: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3 as $d_Lapp_data_GeneralPracticeUserOutOfOffice$$anon$3 };
var $t_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite = null;
function $u_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite(x) {
  $t_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite = x;
}
export { $t_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite as $t_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite, $u_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite as $u_Lapp_data_GeneralPracticeUserOutOfOffice$__Indefinite };
//# sourceMappingURL=app.data.-General-Practice-User-Out-Of-Office.js.map
